import { useCallback } from 'react';

import { useDocumentTypeAssociationsQuery } from './queries';

// Options for 'Select Document Category' dropdown
const useDocumentCategoryOptions = () => {
  const { data: options } = useDocumentTypeAssociationsQuery({
    select: useCallback((data) => {
      const options = new Set<string>();

      data.forEach((category) => {
        options.add(category.documentCategory);
      });

      return Array.from(options).map((category) => ({
        label: category,
        value: category,
      }));
    }, []),
  });

  return options ?? [];
};

export default useDocumentCategoryOptions;
